module.exports = __webpack_public_path__ + "static/media/plant-in-light.9942c166.jpg";